export default __webpack_public_path__ + "resources/icons/d121-8b8d.webp";